export default __webpack_public_path__ + "static/preview_atsent-068874f72a4c7deb4094913acef4501c.png";